module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/offline-plugin-app-shell-fallback.json
// module id = 1293
// module chunks = 210333531512890